// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__24C5v","signatureBlock":"Footer_signatureBlock__338PR","signature":"Footer_signature__2pjVf"};